(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"]) return;
  try {
    

$(function() {
  $('.acc__title').click(function(j) {
    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion"]) return;
  try {
              
jQuery(function($){
  if ($(window).width() > 991) {
    var urrl = window.location.href;
    if( urrl.indexOf('events') != -1 && urrl.indexOf('light_') != -1 ) {
    	$("a.lightbox-close").addClass('open');
		$(".offers").addClass("bg-color-overlay");
  	}

    $(window).scroll(function(){
	    if( $("#pageheader").hasClass("undock") ){
    		$("a.lightbox-close").removeClass("fixedbelowsome");			
    	}
    	else {
			$("a.lightbox-close").addClass("fixedbelowsome");
    	}
    })

    $(".event-image.no-link").click(function(e) {
    e.preventDefault();
	  $(".lightbox-close").removeClass('open');	
	  $(this).next().addClass('open');
	  $(".lightbox-target").removeClass('open');
      $(this).children('.lightbox').siblings(".lightbox-target").addClass('open');
      //$("html").addClass("overflow-body");
      $(".offers").addClass("bg-color-overlay");
      var imagetop = $(".lightbox-target.open img").offset().top;
	  var imageheight = $(".lightbox-target.open img").outerHeight();
	  var windowheight = $(window).outerHeight();
	  var scrolltoop = imagetop - 250;

      $('html, body').animate({scrollTop: scrolltoop});
    });
    $("a.lightbox-close").click(function(e){
	e.preventDefault();
      $(this).removeClass('open');
      $("html").removeClass("overflow-body");
      $(".offers").removeClass("bg-color-overlay");
	  $(".lightbox-target").removeClass('open');
    });
  }
  else {
    $(".event-image.no-link > .lightbox").click(function(event) {
      event.preventDefault();
      $("a.lightbox").attr("href", "");
      $(".offers").removeClass("bg-color-overlay");
	  $("a.lightbox-close.open").hide();	
  	});	
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablayout"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
$('.tab_layout.collection_wrapper .tab').on('click', function() {
const $this = $(this);
const index = $this.index();
console.log("Hi");
$(this).parent().find('.tab').removeClass('active');
$this.addClass('active');
$(this).parent().siblings(".tab_content_here").find(".tab_content_content").removeClass('active');
console.log($(this).parent().siblings(".tab_content_here").find(".tab_content_content"))
$(this).parent().siblings(".tab_content_here").find(".tab_content_content").eq(index).addClass('active');
$(this).parent().siblings(".tab_content_here").find(".tab_content_image").removeClass('active');
$(this).parent().siblings(".tab_content_here").find(".tab_content_image").eq(index).addClass('active');
});
})

  } catch(e) { console.error(e); }
})();
})();
